import runTransaction from "../../utils/runTransaction";
import updateDocumentData from "../../utils/updateDocumentData";

import epubVersions from "../articles/constants/epubVersions";
import updateArticle from "../articles/updateArticle";

import { Artifact } from "./types/Artifact";

export default function updateArtifact(firebase, data, { transaction, filesToDelete = [] } = {}) {
	return runTransaction(
		firebase,
		[data.ref, data.article?.ref],
		async (transaction, [artifact, article]) => {
			if (data.files) {
				data.files = data.files.map((file) => file.id);
			}

			// Update the article (duration) or epub version if this is the default artifact
			if (article?.artifact?.id === data.ref.id && (data.duration || data.format?.version)) {
				const articleData = getDurationOrEpubVersion(data);

				await updateArticle(firebase, { ref: article.ref, artifact, ...articleData }, { transaction });
			}

			transaction.set(data.ref, Artifact.partial().parse(updateDocumentData(firebase, data)), { merge: true });

			for (const file of filesToDelete) {
				transaction.delete(file.ref);
			}
		},
		transaction,
	);
}

export function getDurationOrEpubVersion(data) {
	return data.duration ? { duration: data.duration } : { epubVersion: findEpubVersion(data) };
}

function findEpubVersion(data) {
	return Object.entries(epubVersions).find(
		([_, { contentType, version }]) => data?.contentType === contentType && data?.format?.version === version,
	)?.[0];
}
